<template>
<div>

 <el-row>
   <el-button type="primary" @click="selecPerson()" style="margin-right:20px;">选取其他人员</el-button>
   <sbsp-file-upload :file-ids.sync="multipleSelection" :allSelection="true" limit="5" >

              <el-button type="primary" @click="allSelection()">多人共用文件上传</el-button>
              </sbsp-file-upload>
              </el-row>
  <el-table
    ref="multipleTable"
    :data="tableData"
    tooltip-effect="dark"
    style="width: 100%"
    @selection-change="handleSelectionChange">
    <el-table-column
      type="selection"
      width="55">
    </el-table-column>
    <el-table-column
      label="日期"
      width="120">
      <template slot-scope="scope">{{ scope.row.date }}</template>
    </el-table-column>
    <el-table-column
      prop="name"
      label="姓名"
      width="120">
    </el-table-column>
    <el-table-column
      prop="address"
      label="地址"
      show-overflow-tooltip>
    </el-table-column>
    <el-table-column label="文件">
        <template slot-scope="scope">
        <!-- <el-button
          size="mini"
          @click="upload(scope.$index, scope.row)">上传</el-button> -->
            <div v-for="(fileId,i) in scope.row.fileIds" :key="fileId.uid" class="fileName">
              <el-tooltip v-if="fileId.owner" :content="'附件公用人：'+fileId.owner" placement="bottom" effect="light" >
                <img src="@/assets/img/formUpload/icon-duoren.png" alt="" srcset="">
              </el-tooltip>
              <span :class="{oneOwner:!fileId.owner}">{{fileId.fileName}}</span>  <span class="downLoad" @click="downLoad(fileId.fileId)">下载</span>
           <span class="del" @click="del(fileId.fileId)">删除</span>
            </div>
      </template>
    </el-table-column>
      <el-table-column label="操作">
      <template slot-scope="scope">
        <!-- <el-button
          size="mini"
          @click="upload(scope.$index, scope.row)">上传</el-button> -->

           <span>
            <sbsp-file-upload :file-ids.sync="scope.row.fileIds" limit="5" >
              <div class="upload">
                  上传
              </div>
              </sbsp-file-upload>
           </span>
      </template>
    </el-table-column>
  </el-table>
  <div style="margin-top:30px;">
    <sbspFileUploadDetails></sbspFileUploadDetails>
  </div>
     <el-dialog
      ref=""
      width="70%"
      id="selectPerson"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="选取其他人员"
      :visible.sync="dialogheaderVisible"
    >
     <selectPerson></selectPerson>
    </el-dialog>
  </div>
</template>

<script>
import sbspFileUpload from "@/views/demo/serve/sbsp-file-upload/sbsp-form-file-upload";
import sbspFileUploadDetails from "@/views/demo/serve/sbsp-file-upload/sbsp-form-file-details";
import selectPerson from "@/views/demo/salarySet/template/selectPerson.vue";
 import { downLoadFile,getFileInfo} from "@/api/user/user.js"
 import { downloadFile } from '@/util/util';
  export default {
components: {
    sbspFileUpload,sbspFileUploadDetails,selectPerson
  },
    data() {
      return {
        dialogheaderVisible:false,
        tableData: [{
          date: '2016-05-03',
          name: '王小虎0',
          address: '上海市普陀区金沙江路 1518 弄',
          fileIds:[]
        }, {
          date: '2016-05-02',
          name: '王小虎1',
          address: '上海市普陀区金沙江路 1518 弄',
          fileIds:[]
        }, {
          date: '2016-05-04',
          name: '王小虎2',
          address: '上海市普陀区金沙江路 1518 弄',
          fileIds:[]
//          fileIds:[{uid: 1584440437372, name: "租房合同.docx", lastModified: 1575540313850,owner:"王小虎0 、王小虎2"},{uid: 1584440437372, name: "租房合同.docx", lastModified: 1575540313850,owner:"王小虎1 、王小虎2"}]
        }, {
          date: '2016-05-01',
          name: '王小虎3',
          address: '上海市普陀区金沙江路 1518 弄',
          fileIds:[]
        }, {
          date: '2016-05-08',
          name: '王小虎4',
          address: '上海市普陀区金沙江路 1518 弄',
          fileIds:[]
        }, {
          date: '2016-05-06',
          name: '王小虎5',
          address: '上海市普陀区金沙江路 1518 弄',
          fileIds:[]
        }, {
          date: '2016-05-07',
          name: '王小虎6',
          address: '上海市普陀区金沙江路 1518 弄',
          fileIds:[]
//          fileIds:[
//            {uid: 1584440437376, name: "租房合同.docx", lastModified: 1575540313850},
//            {uid: 1584440437377, name: "租房合同.docx", lastModified: 1575540313850},
//            {uid: 1584440437378, name: "租房合同.docx", lastModified: 1575540313850}
//          ]
        }],
        multipleSelection: []
      }
    },

    methods: {
      allSelection(rows) {

      },
      selecPerson(){
        this. dialogheaderVisible = true;
      },
      downLoad(id){
          downLoadFile(id).then(res => {
                    console.log(res)
                    downloadFile(res)
                })
      },
      del(){

      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      }
    }
  }
</script>
<style scoped>
.downLoad,.del{
  font-size:12px;
  margin-left: 20px;
  font-weight:500;
  color:rgba(64,158,255,1);
  line-height:17px;
  cursor: pointer;
}
.fileName{
  padding-bottom: 10px;
  line-height: 17px;
}
.fileName img,.fileName span{
  vertical-align: middle;
}
.fileName span{
  height:17px;
  line-height:17px;
}
.fileName span.oneOwner{
  padding-left:42px;
}
.fileName img{
  margin-right: 20px;
}
.fileName:nth-last-of-type(1){
  padding-bottom: 0;
}
.el-row{
  text-align: right;
  margin-bottom: 10px;
}
  .upload{
    font-size:12px;
  margin-right: 50px;
  font-weight:500;
  color:rgba(64,158,255,1);
  line-height:17px;
  }
</style>
